document.addEventListener('click', (event) => {
  const anchor = event.target.closest('header-drawer a[href*="#arome-"]');
  if (!anchor) return;
  const url = new URL(anchor.href);
  if (url.origin !== location.origin || url.pathname !== location.pathname) return;
  const target = document.getElementById(url.hash.slice(1));
  if (!target) return;
  const drawer = anchor.closest('header-drawer');
  drawer?.closeMenuDrawer(event);
  drawer?.querySelector('summary')?.setAttribute('aria-expanded', 'false');
  target.setAttribute('tabindex', '-1');
  target.focus({ preventScroll: true });
});

document.addEventListener('arome:cart-state', (event) => {
  const { cart, threshold } = event.detail;
  document.querySelectorAll('[data-ar-cart-invite]').forEach((element) => {
    const message = element.querySelector('[data-ar-cart-message]');
    const link = element.querySelector('[data-ar-cart-link]');
    if (!message || !link || cart.currency !== 'MXN') return;
    const remaining = Math.max(0, threshold - cart.total_price);
    const amount = new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN', minimumFractionDigits: remaining % 100 === 0 ? 0 : 2 }).format(remaining / 100);
    message.textContent = remaining === 0
      ? 'Tu pedido ya tiene envío gratis a todo México.'
      : `Te faltan ${amount} para obtener envío gratis. Encuentra tu segundo favorito.`;
    link.hidden = remaining === 0;
  });
});
